// extracted by mini-css-extract-plugin
export var navbarSubLink = "D_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "D_tN d_f0 d_dB";
export var subPageLink = "D_gf d_gf";
export var burger = "D_vt";
export var sublinkSize = "D_vv";
export var linkSize = "D_vw";
export var Link = "D_rG q_rG q_qT q_rc";